import type { FooterLink } from '../../../../../types';

export default [
  {
    name: 'Privacy policy',
    href: '/privacy-policy',
    rel: 'nofollow',
    analytics: 'footer:privacy+policy',
  },
  {
    name: 'Terms & Conditions',
    href: '/terms-and-conditions',
    rel: 'nofollow',
    analytics: 'footer:terms+conditions',
  },
  {
    name: 'SEEK safely',
    href: '/safe-searching',
    rel: 'nofollow',
    analytics: 'footer:seek+safely',
  },
  {
    name: 'Contact us',
    href: '/contact-us',
    rel: 'nofollow',
    analytics: 'footer:contact+us',
  },
] as FooterLink[];
